<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :modal-append-to-body='false' :append-to-body="true")
        el-form(:model="ruleForm",:inline="false", :rules="rules", ref="ruleForm" label-width="130px")
            el-card(shadow="never")
                div
                    el-form-item(label="比赛ID:" prop="matchId")
                        font {{ruleForm.matchId}}
                    el-form-item(label="比赛名称:" prop="matchName")
                        font {{ruleForm.matchName}}
                    el-form-item(label="主办方:" prop="microOrgName")
                        font {{ruleForm.microOrgName}}
            br

            el-card(shadow="never" v-if="type == 'release'")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 审核意见
                div
                    el-form-item(label="审核意见:" prop="matchStatus")
                        el-select.sel_width_ct(v-model='ruleForm.matchStatus' @change=''  placeholder="请选择比赛类型"  clearable)
                            el-option(label="审核通过" :value='1')
                            el-option(label="审核不通过" :value='0')
            
            br
            el-card(shadow="never" v-if='ruleForm.matchStatus == 1&&matchType!=4')
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 审核配置
                el-form-item(prop="isScore" label="是否配置积分:")
                    el-radio(v-model="ruleForm.isScore" :label='0') 是
                    el-radio(v-model="ruleForm.isScore" :label='1') 否   

            el-card(shadow="never" v-if='ruleForm.isScore == 0 && ruleForm.matchStatus == 1')
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 积分配置
                div
                    el-form-item(prop="basisPoints" label="基准分:")
                        el-input(v-model='ruleForm.basisPoints' clearable placeholder="请填写基准分")
                    el-form-item(prop="increasingPoints" label="递增分:")
                        el-input(v-model='ruleForm.increasingPoints' clearable placeholder="请填写递增分")
                    el-form-item(prop="rewardPoint" label="额外附加分:")
                        el-input(v-model='ruleForm.rewardPoint' clearable placeholder="请填写额外附加分")
                    

            br
            el-card(shadow="never" v-if='ruleForm.matchStatus == 0')
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 不通过原因
                div
                    el-form-item(prop="verifyReason" label="不通过原因:")
                        el-input(v-model="ruleForm.verifyReason" type="textarea" :rows=5 resize="none")    

        span.dialog-footer(slot="footer" v-if="!type")
            el-button(@click="visible=false") 返 回
        //审核发布
        span.dialog-footer(slot="footer" v-if="type == 'release'")
            el-button(@click="releaseSubmit(2)" type="primary") 发 布
            //- el-button(@click="releaseSubmit(5)" type="danger") 拒 绝
            el-button(@click="visible=false") 取 消
        //- //支付弹窗组件
        zfpage(:openfree='visibleFee' :record='record' v-if="visibleFee" @zfsuccess="zfsuccess")

</template>
<script>
import zfpage from "../zfpage.vue";
export default {
  components: {
    zfpage,
  },
  data() {
    return {
      visibleFee: false,
      record: {},
      type: "",
      matchType: "",
      title: "查看详情",
      tableData: [
        {
          dataName: "团队费用",
          price: 0.0,
        },
      ],
      defaultImg: "",
      listImageUrl: "",
      detailImageUrl: "",
      ruleForm: {
        id: null,
        matchId: "",
        matchName: "",
        microOrgName: "",
        isScore: "0",
        basisPoints: "",
        increasingPoints: "",
        rewardPoint: "",
        verifyReason: "",
        matchStatus: "1",
      },
      visible: false,
      rules: {
        isScore: [
          { required: true, message: "是否配置积分不能为空!", trigger: "blur" },
        ],
        basisPoints: [
          {
            required: true,
            message: "基础分不能为空!",
            trigger: "change",
          },
        ],
        increasingPoints: [
          {
            required: true,
            message: "递增分不能为空!",
            trigger: "change",
          },
        ],
        rewardPoint: [
          {
            required: true,
            message: "附加分不能为空!",
            trigger: "change",
          },
        ],
        verifyReason: [
          {
            required: true,
            message: "不通过原因不能为空!",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    zfsuccess(data) {
      this.visibleFee = false;
      console.log(data, 789);
      if (data == 1) {
        // this.$showLoading()
        this.$http({
          url: this.$http.adornUrl(`/frFranchiseFeeRecord/checkPayStatus`),
          method: "post",
          data: {
            busId: this.ruleForm.id,
            busType: 1,
            busCategory: 2,
          },
        }).then((data) => {
          if (data && data.code === 0) {
            this.visible = false;
            //缴费成功，直接发布
            this.updateState(2);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    init(row, type) {
      this.title = "查看详情";
      this.ruleForm.id = row.id || null;
      this.visible = true;
      this.type = type;
      this.matchType=row.matchType;
      if (type === "release") {
        this.title = "审核发布";
        // this.finachiseFeePay()
      }
      this.ruleForm.verifyReason = "";
      //回选
      if (this.ruleForm.id) {
        // this.$http({
        // 	url: this.$http.adornUrl(
        // 		`/ctCompetition/getId/` + this.ruleForm.id
        // 	),
        // 	method: 'get'
        // }).then((data) => {
        // 	if (data && data.code === 0) {
        console.log(row);
        this.ruleForm = row;
        this.ruleForm.verifyReason = "";
        let index = 1;
        // }
        // })
      }
    },
    releaseSubmit(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$confirm("是否审核比赛?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              // 迭代三调试暂时关闭功能，直接打开下面注释即可

              // //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
              // //status状态(0未缴费，1已缴费，2已退费)
              // if (this.record.type === 1 && this.record.status === 0) {
              //   //仅未支付预缴费时，展示二维码支付页面
              //   this.visibleFee = true
              // } else {
              //   //不是预缴费，则直接发布
              //   this.updateState(type)
              // }
              // 迭代三调试暂时关闭功能，直接注释即可下面
              this.updateState();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消发布",
              });
            });
        }
      });
    },
    // 数据处理
    CompetitionSelection(val, index) {
      if (val) {
        if (this.ruleForm.competitionMatchFormatList.length > 0) {
          if (val.length && index == 1) {
            return this.ruleForm.competitionMatchFormatList[0].matchFormat == 0
              ? "淘汰附加赛"
              : this.ruleForm.competitionMatchFormatList[0].matchFormat == 1
              ? "小组循环赛"
              : "";
          }
          if (val.length && index == 11) {
            return this.ruleForm.competitionMatchFormatList[0].groupNum;
          }
        }

        if (this.ruleForm.competitionMatchFormatList.length > 1) {
          if (val.length && index == 2) {
            return this.ruleForm.competitionMatchFormatList[1].matchFormat == 2
              ? "同名次小组循环赛"
              : this.ruleForm.competitionMatchFormatList[1].matchFormat == 3
              ? "同名次淘汰附加赛"
              : this.ruleForm.competitionMatchFormatList[1].matchFormat == 4
              ? "交叉淘汰附加赛"
              : "";
          }
          if (val.length && index == 22) {
            return this.ruleForm.competitionMatchFormatList[1].crossNum;
          }
        }
      }
    },
    updateState() {
      console.log(this.ruleForm);
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/micro/IssuedAudit`),
        method: "post",
        data: this.$http.adornParams({
          ctId: this.ruleForm.id,
          matchStatus: this.ruleForm.matchStatus == 1 ? true : false,
          isScore: this.matchType==3?this.ruleForm.isScore:1,
          basisPoints: this.ruleForm.basisPoints,
          increasingPoints: this.ruleForm.increasingPoints,
          rewardPoint: this.ruleForm.rewardPoint,
          verifyReason: this.ruleForm.verifyReason,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: "审核成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.visible = false;
              this.$emit("refreshDataList");
            },
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
};
</script>
<style>
.comecs .el-form-item__content {
  display: flex;
}
/* 比赛简介 */
p {
  margin: 0;
}
</style>
